import { SIMILAR_TO } from 'common/constants/messages/validations';

/**
 * Validates that a value is different than another field's value
 * @param value - The value to validate
 * @param options - The options containing the field to compare against
 * @param key - The key of the field being validated
 * @param attributes - The object containing all form values
 */

/*
Based on the validate.js documentation, it passes parameters as separate arguments
rather than as a single object. That is why we are not using an interface.
*/

export const differentThanValidator = (
  value: string,
  options: { field: string, message: string },
  _key: string,
  attributes: Record<string, string>
): string | null => {
  const tmpValue = value ?? '';
  const field = options.field ?? '';
  const fieldValue = attributes[field] ?? '';
  const areSimilar = tmpValue.toString().toLowerCase().includes(fieldValue.toString().toLowerCase());

  return areSimilar ? SIMILAR_TO(field) : null;
};
